/**
 * Data information mock
 */

// Image
import { IMAGES } from 'assets/images';
import { audio_analysis_light, digital_survey_light } from 'assets/icons';

// Utils
import { DataSystemInformation } from 'utils/types';

const { phone } = IMAGES;
export const dataSystemInformation: DataSystemInformation[] = [
  {
    id: 1,
    icon: phone,
    content: 'デジタルアンケート',
    title: 'アイコン（ホーム画面）',
  },
  {
    id: 2,
    content: '',
    icon: audio_analysis_light,
    title: 'アイコン（AF管理画面（利用中））',
  },
  {
    id: 3,
    content: '',
    title: 'アイコン（AF管理画面（申請中））',
    icon: digital_survey_light,
  },
];
